export default __webpack_public_path__ + "static/media/1_0086.b492dc8c.webp";